import { call, put, takeLatest } from "redux-saga/effects";
import { httpGetSchools } from "../../../services/questions";
import {
  getSchoolsStart,
  getSchoolsSuccess,
  getSchoolsFailure,
} from "../reducer";

function* getSchools({ payload }) {
  const response = yield call(httpGetSchools, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getSchoolsSuccess(raw));
  } else {
    yield put(getSchoolsFailure(message || raw?.error));
  }
}

export default function* onGetSchools() {
  yield takeLatest(getSchoolsStart.type, getSchools);
}
